import React from "react";
import "./styles.less";

export const Title = (props) => {
  const {
    children,
    title,
    size = "h1",
    textAlign = "center",
    paddingBottom,
  } = props;
  const fontsize = {
    h1: "36px",
    h2: "24px",
    h3: "16px",
    h4: "14px",
  };
  const style = {
    fontSize: fontsize[size],
    textAlign: textAlign,
    paddingBottom: paddingBottom,
  };
  return (
    <div className="authing-title-wrapper">
      <div className="title" style={style}>
        {title}
      </div>
      <div className="description">{children}</div>
    </div>
  );
};
